<div class="container">
  <div class="heading mat-typography">
    <div> Server information </div>
    <div class="icon">
      <mat-icon (click)="closeModal()">close</mat-icon>
    </div>
  </div>
  @if (server) {
  <div class="content">
    <div class="server-info mat-typography">
      <div class="server-detail">
        <span class="head">Server IP:</span>
        <span class="value">{{ server?.IPAddress }}</span>
      </div>
      <div class="server-detail">
        <span class="head">Server Group:</span>
        <span class="value">{{ server?.GroupName }}</span>
      </div>
    </div>
    <div class="server-link-info">
      <app-card-table
        [data]="serverLinkData"
        [tableHeaders]="resultsHeaders"
        [options]="options"
        [enableInfiteScroll]="false"
        [enableTablePagination]="true"
        [enableRefresher]="false"
        [totalItems]="serverLinkData.length"
        [currentPage]="currentPage"
        (paginateEvent)="onPageChange($event)"
        [breakpoint]="ScreenSize.TABLET"
      >
      </app-card-table>
    </div>
  </div>
  }
</div>
